import './index.scss';

const Label = ({forHtml, label}) => {
  return <label htmlFor={forHtml} className='label' >{label}</label>;
};

export default Label;
